import React from 'react';
import styled from '@emotion/styled';
import { HeartbeatResult } from 'services/useStandBy';

const StandByFrameOuter = styled.div({
    position: 'relative',
});

const StandByFrameInner = styled.div<{ darkMode: boolean }>(props => ({
    position: 'absolute',
    top: '5px',
    left: '5px',
    margin: 'auto',
    width: 'calc(100% - 10px)',
    height: 'calc(100% - 10px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: props.darkMode ? 'rgba(0, 0, 0, 0.4)' : 'rgb(255, 255, 255, 0.8)',
    borderRadius: '10pt',
}));

const StandByButton = styled.button({
    fontSize: 'x-large',
});

const StandByHeartbeat = styled.div<{ isHeartbeatHealthy: boolean }>(props => ({
    position: 'absolute',
    top: '5px',
    left: '5px',
    color: props.isHeartbeatHealthy ? 'green' : 'red',
}));

const NOT_YET: HeartbeatResult = { status: 'stopped' };

function getStandByMessage(heartbeatStatus: HeartbeatResult) {
    switch (heartbeatStatus.status) {
        case 'beating':
            return { message: '● HEALTHY' };
        case 'stopped':
            return { message: '● WARNING', reason: 'no heartbeat' };
        case 'rejected':
            return { message: '● WARNING', reason: 'rejected by vehicle' };
        case 'too-slow':
            {
                const { delay } = heartbeatStatus;
                return { message: '● WARNING', reason: `too slow (${delay}ms)` };
            }
    }
}

export type StandByFrameProps = {
    standby: boolean;
    onClick?: () => void;
    darkMode?: boolean;
    heartbeatStatus: HeartbeatResult | undefined;
    isStandByAllowed?: boolean;
}

export function StandByFrame(props: React.PropsWithChildren<StandByFrameProps>) {
    const { standby, onClick, darkMode = false, heartbeatStatus = NOT_YET, isStandByAllowed = false, children } = props;
    const { message, reason } = getStandByMessage(heartbeatStatus);
    return standby
        ? <StandByFrameOuter>
            {children}
            <StandByHeartbeat isHeartbeatHealthy={heartbeatStatus.status === 'beating'}>
                {
                    reason ? <div>{message}: {reason}</div> : <div>{message}</div>
                }
            </StandByHeartbeat>
        </StandByFrameOuter>
        : <StandByFrameOuter>
            {children}
            <StandByFrameInner darkMode={darkMode}>
                <StandByButton onClick={onClick} disabled={!isStandByAllowed}>Stand By</StandByButton>
            </StandByFrameInner>
        </StandByFrameOuter>;
}
